import { FixedMountPoint, FixedMountPointProps } from '@packages/portals/lib/FixedMountPoint';
import { createMemo } from '@packages/react';
import React from 'react';

export const OutsideMountPoint = createMemo<Omit<FixedMountPointProps, 'name'>, { POINT: string }>(
    (props) => <FixedMountPoint name={OutsideMountPoint.POINT} top={-9999} left={-9999} {...props} />,
    {
        displayName: 'OutsideMountPoint',
        POINT: 'layout-out-elements',
    },
);
